<template>
  <div v-if="!isLoading">
    <div v-if="isMultiBand && !isRecommendLoading">
      <template v-if="multisectionList.length > 0 && recommendViewType === ''">
        <div class="search-result-multi-band-container">
          <div v-for="(sectionInfo, index) in multisectionList" :key="sectionInfo.title + index" class="multi-section-container">
            <DynamicSectionLoader :section-info="sectionInfo" :keyword="searchKeyword" :key="sectionInfo.title"></DynamicSectionLoader>
          </div>
        </div>
      </template>
      <search-empty-message v-else
                            :recommend-cell-list="recommendCellList"
                            :search-keyword="searchKeyword"
                            :change-keyword="changeKeyword"
                            :keyword-list="keywordList"
                            :thumbnail-info="thumbnailInfo"
                            :re-search-by-fixec-keyword-fn="reSearchByFixedKeyword"
                            :move-to-recommend-tag-fn="moveToRecommendTag"
      />
    </div>
    <div v-else>
      <search-result-list :type="searchCategory" :keyword="searchKeyword" :mType="mType"></search-result-list>
    </div>
  </div>
</template>

<script>
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import SearchResultList from '@/components/search/SearchResultList'
import { SearchService } from '@/common/api/api.service'
import { parse } from 'query-string'
import { get } from 'lodash'
import { getClampText } from '@/common/util/text.utils'
import { PATH_NAME_SEARCH_LIST } from '@/common/router.const'
import MultiSectionModel from '@/common/model/MultiSectionModel'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import SearchEmptyMessage from '@/components/search/SearchEmptyMessage'
import { sendEventLogSearchRecommendTag } from '@/common/util/log.v2.send'
import { setTransactionKeyToStorage } from '@/common/util/storage.util'
import { MOBILE_WEB_HOSTNAME } from '@/common/constant'

export default {
  name: 'searchKeywordResult',
  components: {
    SearchEmptyMessage,
    DynamicSectionLoader,
    SearchResultList
  },
  data () {
    return {
      searchKeyword: '',
      keywordList: [],
      recentKeyword: '',
      changeKeyword: '',
      multisectionList: [],
      searchCategory: 'all',
      isLoading: true,
      recommendCellList: [],
      mType: 'all',
      thumbnailInfo: {},
      isRecommendLoading: true,
      totalCount: 0,
      recommendViewType: ''
    }
  },
  computed: {
    isMultiBand () {
      return get(this.$route, 'query.searchCategory', 'all') === 'all'
    },
    isEmptyMultisection () {
      console.log(this.recommendViewType !== '' || this.keywordList.length > 0)
      return this.recommendViewType !== '' || this.keywordList.length > 0
    }
  },
  methods: {
    getCellListContainerClassName (thumbnailInfo) {
      return `cell-list responsive cell-${thumbnailInfo.type}`
    },
    setSearchByKeyword () {
      this.isLoading = true
      if (this.searchKeyword === '') return
      SearchService.keywordSearchCF({
        offset: 0,
        limit: 5,
        orderby: 'score',
        type: 'all',
        keyword: this.searchKeyword,
        mtype: 'all'
      }).then(({ data }) => {
        this.changeKeyword = get(data, 'changekeyword', '')
        this.multisectionList = get(data, 'multisectionlist', []).map((multiSection) => {
          return new MultiSectionModel(multiSection)
        })
        this.totalCount = Number(get(data, 'totalcount', 0))
        this.recommendViewType = get(data, 'recommendviewtype', '')
        if (get(data, 'recommendviewtype', '') !== '') {
          this.getRecommendContentsList(get(data, 'recommendviewtype', ''))
        } else {
          this.whenEmptyRecentTagThenSetData()
        }
        setTransactionKeyToStorage(data)
        this.isLoading = false
      })
    },
    getClampText: getClampText,
    getRecommendContentsList (type) {
      this.isRecommendLoading = true
      SearchService.getRecommendList({ keyword: this.searchKeyword, offset: 0, limit: 20, type })
        .then(({ data }) => {
          const cellType = get(data, 'cell_toplist.cell_type', '')
          this.thumbnailInfo = getBandTypeInfoByCellType(cellType)
          this.recommendCellList = get(data, 'cell_toplist.celllist', [])
          this.isRecommendLoading = false
        })
    },
    whenEmptyRecentTagThenSetData () {
      this.isRecommendLoading = true
      SearchService.getRecommendSearchKeywordList().then(({ data }) => {
        this.keywordList = Object.assign([], data).splice(0, 5)
        this.isRecommendLoading = false
      })
    },
    moveToRecommendTag (keywordItem) {
      const { link, text } = keywordItem
      const uiCode = get(parse(link.split('?').pop()), 'uicode', '')

      sendEventLogSearchRecommendTag({ keyword: text, landingUrl: link })
      if (uiCode !== '') {
        this.$router.push({ name: PATH_NAME_SEARCH_LIST, params: { uiCode: uiCode, section: uiCode } })
      } else {
        this.$router.replace(
          link.replace('captvpooq://', '')
            .replace(MOBILE_WEB_HOSTNAME, '')
            .replace('https://', '')
        )
      }
    },
    reSearchByFixedKeyword () {
      this.searchKeyword = this.changeKeyword
      this.setSearchByKeyword()
    },
    init () {
      this.recommendCellList = []
      this.keywordList = []
      this.searchKeyword = get(this.$route, 'query.searchWord', '')
      this.searchCategory = get(this.$route, 'query.searchCategory', 'all')
      this.mType = get(this.$route, 'query.mType', 'all')
      this.recentKeyword = this.keyword
    },
    load () {
      this.init()
      if (this.searchKeyword !== '') this.setSearchByKeyword()
    }
  },
  created () {
    this.load()
  },
  watch: {
    $route () {
      this.load()
    }
  }

}
</script>
<!--<style lang="css" src="@/assets/new-css/search.css"></style>-->
<style scoped>
.search-result-multi-band-container {
  /*overflow-scrolling: touch;*/
  /*-webkit-overflow-scrolling: touch;*/
  /*overflow-y: scroll;*/
  /*overflow-y: scroll;*/
  background-color: #1b1b1b;
}
.search-result-multi-band-container::-webkit-scrollbar{
  display: none;
  background-color: transparent
}
.recent-keyword-empty {
  position: relative;
  width: 100%;
  height: 100%;
}
.attention-mark-area .icon {
  position: relative;
  width: 50px;
  height: 50px;
  margin: 0 auto;
}
.info-text {
  margin-top: 16px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #a5a5a5;
}
.recommend-keyword-list {
  position: relative;
  top: 34px;
  width: 100%;
  padding: 0 5px 0 5px;
  height: 190px;
  text-align: center;
}
.btn-research {
  display: block;
  margin-top: 40px;
  font-size: 12px;
  line-height: 18px;
  color: #a5a5a5;
  text-align: center;
}
.btn-research span,
.btn-research svg{
  vertical-align: middle;
}
.btn-research > svg{
  width: 18px;
  line-height: 18px;
}
.btn-research span + svg{
  margin-left: 4px;
}

/* 검색 결과 > 카테고리 */
.cell-category li{
  width: 160px;
  height: 80px;
  background-color: #252525;
}
.cell-category a{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80px;
}
.cell-category a > span + strong{
  margin-top: 2px;
}
.cell-category a > span{
  font-size: 12px;
  line-height: 14px;
  color: #a5a5a5;
}
.cell-category a > strong{
  font-size: 14px;
  line-height: 20px;
  color: #fff;
}
</style>
